import { get } from 'communication/httpClient';

export const getLaunchDarklyKey = async () => {
  const { data, error } = await get('/api/configuration');
  if (data) return data;
  if (error) return '';
};
